import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { fromHistory } from '@root-store/index';

import { HistorySystemEffect, HistorySystemProtectedEffect } from './system/history-system.effect';

@NgModule({
  imports: [
    // declare store reducers
    StoreModule.forFeature(fromHistory.featureName, fromHistory.reducers, {
      initialState: fromHistory.initialState,
      metaReducers: fromHistory.metaReducers,
    }),
    // declare store effects
    EffectsModule.forFeature([HistorySystemProtectedEffect, HistorySystemEffect]),
  ],
})
export class HistoryStoreModule {}
